import { Component, Prop, Vue, Mixins } from 'vue-property-decorator';
import { FavoriteList, UpdateFavoriteListCommand, CreateFavoriteListCommand, FavoriteListViewModel } from "Api/CoreApi";
import store from "Store/index"
import UserMixin from 'Mixins/UserMixin';
import BaseComponent from 'Components/Base/ABaseComponent';

@Component({
    template: "#favorite-list-overview-template"
})
export default class FavoriteListOverviewComponent extends BaseComponent {
    public newName: string = ""; 
    public showNew: boolean = false; 

    get favoritelists(): FavoriteListViewModel[] {
        return store.state.favoriteList.favoriteLists;
    }

    async created() {
        this.setLoading();
        await store.dispatch.favoriteList.loadFavoriteListDetails();
        this.setLoaded();
    }

    async updateName(id:number, name:string) {
        store.dispatch.favoriteList.updateFavoriteList(new UpdateFavoriteListCommand({
            id: id,
            name:name
        }));
    }
    
    get lists(){
        //hack- triggers getter if property values changes
        const somethingHasChanged = store.state.favoriteList.detectChanges;
        return store.state.favoriteList.favoriteLists;
    }

    get showlist(){
        return this.lists? this.lists.length > 0 : false; 
    }

    async createFavoriteList() {
        store.dispatch.favoriteList.createFavoriteList(new CreateFavoriteListCommand({
            name: this.newName
        }));
        //Reset variables 
        this.showNew = false;
        this.newName = ""; 
    }

    async show() {
        this.showNew = true; 
    }


}

Vue.component('favorite-list-overview', FavoriteListOverviewComponent);